<template>
  <div>
    <div class="bg-secondary text-white px-4 py-5 position-relative">
      <div v-background="require('@/assets/photo-header.jpg')" class="header-background"/>
      <div class="container my-2">
        <div class="row">
          <div class="col-9">
            <h1>Bienvenue sur l'espace de réservation hôtelière pour le SPACE 2024</h1>
            <p class="mt-3">Welcome to the hotel booking website for SPACE 2024</p>
          </div>
        </div>
      </div>
    </div>
    <div v-background="require('@/assets/white_plaster.png')" class="px-4 py-5">
      <div class="container text-secondary">
        <template v-if="sent">
          <h2>Merci de nous avoir contactés</h2>
          <p>Nous vous répondrons dans les plus brefs délais</p>
          <router-link tag="button" to="/" class="btn btn-primary" exact>Revenir à l'accueil</router-link>
        </template>
        <template v-else>
          <h2>Nous contacter</h2>
          <p>Si vous souhaitez contacter l'agence, vous pouvez nous joindre par téléphone, par email, ou nous envoyer directement un message en utilisant le formulaire ci-dessous.</p>
          <p>
            Tel :
            <a href="tel:+33299149547">+33 (0)2 99 14 95 47</a>
          </p>
          <p>
            Email :
            <a href="mailto:space@visit-ouest.com">space@visit-ouest.com</a>
          </p>
          <hr>
          <form @submit.prevent="contact()">
            <div class="row">
              <div class="col-12 col-md-3">
                <div class="form-group">
                  <label>Civilité</label>
                  <select class="form-control" v-model="form.civility">
                    <option value>Non précisé</option>
                    <option value="Madame">Madame</option>
                    <option value="Monsieur">Monsieur</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label>
                    Prénom
                    <em>/ First name</em>
                    <span class="ml-2 text-primary">*</span>
                  </label>
                  <input type="text" class="form-control" v-model="form.firstName" required>
                </div>

                <div class="form-group">
                  <label>
                    Nom
                    <em>/ Last name</em>
                    <span class="ml-2 text-primary">*</span>
                  </label>
                  <input type="text" class="form-control" v-model="form.lastName" required>
                </div>

                <div class="form-group">
                  <label>
                    E-mail
                    <span class="text-primary">*</span>
                  </label>
                  <input type="email" class="form-control" v-model="form.email" required>
                </div>
                <div class="form-group">
                  <label>Téléphone</label>
                  <input type="phone" class="form-control" v-model="form.phoneNumber">
                </div>

                <div class="form-group">
                  <label>
                    Message
                    <span class="text-primary">*</span>
                  </label>
                  <textarea class="form-control" required rows="7" v-model="form.message"></textarea>
                </div>

                <div class="text-primary">* champs obligatoires</div>
                <button type="submit" class="btn btn-primary">Envoyer</button>
              </div>
            </div>
          </form>
        </template>
      </div>
    </div>
    <ErrorModal v-model="showError" :error="error"/>
  </div>
</template>

<script>
import ErrorModal from "@/components/ErrorModal";

export default {
  name: "Contact",
  components: { ErrorModal },

  data() {
    return {
      form: {},
      sent: false,

      showError: false,
      error: { title: "", message: "" }
    };
  },

  methods: {
    async contact() {
      const sendContactMail = this.$functions.httpsCallable("sendContactMail");
      try {
        await sendContactMail({ ...this.form });

        this.sent = true;
      } catch (error) {
        this.error = {
          title: "Impossible d'envoyer le mail de contact",
          message: error.message
        };
        this.showError = true;
      }
    }
  }
};
</script>